import { apiClient, safeApi } from '../../utils/axiosWithAuth';
import { ApiResponse } from '../../utils/axiosWithAuth';
import { CategoryDTO, CreateCategoryDTO, CategoryPaginationResponse } from '../../types/category';

const buildCategoryFormData = (dto: Record<string, any>, imageFile?: File | null): FormData | null => {
  if (!imageFile) return null;
  const formData = new FormData();
  formData.append('image', imageFile);
  Object.entries(dto).forEach(([key, value]) => {
    if (key !== 'image' && value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  });
  return formData;
};

export const createCategoryAPI = (dto: CreateCategoryDTO, imageFile?: File | null) => {
  const formData = buildCategoryFormData(dto, imageFile);
  return safeApi<{ uuid: string }>(() =>
    formData
      ? apiClient.post<ApiResponse<{ uuid: string }>>('/inventory/categories', formData, {
          headers: { 'Content-Type': undefined },
        })
      : apiClient.post<ApiResponse<{ uuid: string }>>('/inventory/categories', dto)
  );
};

export const updateCategoryAPI = (uuid: string, dto: Partial<CreateCategoryDTO>, imageFile?: File | null) => {
  const formData = buildCategoryFormData(dto, imageFile);
  return safeApi<CategoryDTO>(() =>
    formData
      ? apiClient.put<ApiResponse<CategoryDTO>>(`/inventory/categories/${uuid}`, formData, {
          headers: { 'Content-Type': undefined },
        })
      : apiClient.put<ApiResponse<CategoryDTO>>(`/inventory/categories/${uuid}`, dto)
  );
};

export const deleteCategoryAPI = (uuid: string) =>
  safeApi<{ deleted: boolean }>(() =>
    apiClient.delete<ApiResponse<{ deleted: boolean }>>(`/inventory/categories/${uuid}`)
  );

export const fetchCategoriesAPI = (page = 1, limit = 10, search?: string, status?: string) =>
  safeApi<CategoryPaginationResponse>(() =>
    apiClient.get<ApiResponse<CategoryPaginationResponse>>(
      `/inventory/categories?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${
        status ? `&status=${status}` : ''
      }`
    )
  );

export const fetchOneCategoryAPI = (uuid: string) =>
  safeApi<CategoryDTO>(() =>
    apiClient.get<ApiResponse<CategoryDTO>>(`/inventory/categories/${uuid}`)
  );

export const fetchCategoriesDropdownAPI = (search?: string) =>
  safeApi<CategoryDTO[]>(() =>
    apiClient.get<ApiResponse<CategoryDTO[]>>(`/inventory/categories/dropdown`, {
      params: search ? { search } : undefined
    })
  );
